import { Injectable } from '@angular/core';
import { Logger } from 'angular2-logger/core';
import { Config } from './config.service';
import { StringUtils } from './string-utils.service';
import { environment } from '../environments/environment';
import { HttpRequestUtils } from './util/http-request-utils';
var DEV_MODE_PARAM = 'devMode';
/**
 * LoggerService to log.  Allows logger to be changed at runtime
 * To set the logger level in the console run logger.level=logger.Level.DEBUG
 */
var LoggerService = (function () {
    function LoggerService(config, logger, stringUtils) {
        this.config = config;
        this.logger = logger;
        this.stringUtils = stringUtils;
        this.showLogs = true;
        logger.info('Setting the logger...');
        this.httpRequestUtils = new HttpRequestUtils();
        this.showLogs = this.shouldShowLogs();
        if (this.showLogs) {
            logger.info('Developer mode logger on');
            logger.level = logger.Level.LOG;
        }
    }
    LoggerService.prototype.info = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (optionalParams && optionalParams.length > 0) {
            this.logger.info(this.wrapMessage(message), optionalParams);
        }
        else {
            this.logger.info(this.wrapMessage(message));
        }
    };
    LoggerService.prototype.error = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (optionalParams && optionalParams.length > 0) {
            this.logger.error(this.wrapMessage(message), optionalParams);
        }
        else {
            this.logger.error(this.wrapMessage(message));
        }
    };
    LoggerService.prototype.warn = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (optionalParams && optionalParams.length > 0) {
            this.logger.warn(this.wrapMessage(message), optionalParams);
        }
        else {
            this.logger.warn(this.wrapMessage(message));
        }
    };
    LoggerService.prototype.debug = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (optionalParams && optionalParams.length > 0) {
            this.logger.debug(this.wrapMessage(message), optionalParams);
        }
        else {
            this.logger.debug(this.wrapMessage(message));
        }
    };
    /**
     * Determine if angular should show lo
     * @returns {boolean}
     */
    LoggerService.prototype.shouldShowLogs = function () {
        var devMode = this.httpRequestUtils.getQueryStringParam(DEV_MODE_PARAM);
        return !environment.production || devMode === 'on';
    }; // isProduction.
    LoggerService.prototype.wrapMessage = function (message) {
        // on prod, we do not attach the caller.
        return this.showLogs ? message : this.getCaller() + '>> ' + message;
    };
    LoggerService.prototype.getCaller = function () {
        var caller = 'unknown';
        try {
            throw new Error();
        }
        catch (e) {
            caller = this.cleanCaller(this.stringUtils.getLine(e.stack, 4));
        }
        return caller;
    };
    LoggerService.prototype.cleanCaller = function (caller) {
        return caller ? caller.trim().substr(3) : 'unknown';
    };
    return LoggerService;
}());
export { LoggerService };
LoggerService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
LoggerService.ctorParameters = function () { return [
    { type: Config, },
    { type: Logger, },
    { type: StringUtils, },
]; };
//# sourceMappingURL=logger.service.js.map